"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiChipOverrides = void 0;
var styles_1 = require("@material-ui/core/styles");
var createMuiChipOverrides = function (_a) {
    var spacing = _a.spacing, shape = _a.shape, palette = _a.palette, typography = _a.typography;
    return ({
        root: __assign(__assign({}, typography.caption), { height: spacing(6), borderRadius: shape.borderRadius, color: palette.text.primary, 
            // Contrast level 2
            backgroundColor: styles_1.alpha(palette.type === "dark" ? palette.common.white : palette.common.offBlack, 0.16) }),
        sizeSmall: __assign(__assign({}, typography.overline), { height: spacing(4) }),
        label: {
            paddingLeft: spacing(2),
            paddingRight: spacing(2),
        },
        labelSmall: {
            paddingLeft: spacing(1),
            paddingRight: spacing(1),
        },
        icon: {
            color: "inherit",
            marginLeft: spacing(1),
            marginRight: spacing(-1),
        },
        clickable: {
            // Replace :focus with $focusVisible
            "&:hover, &:focus": {
                // Contrast level 2 + hover
                backgroundColor: styles_1.alpha(palette.type === "dark"
                    ? palette.common.white
                    : palette.common.offBlack, 0.16 + palette.action.hoverOpacity),
            },
            "&:hover": {
                boxShadow: "inset 0 0 0 1px " + palette.text.primary,
            },
            // Disable default
            "&:active": {
                boxShadow: undefined,
                // Increase specificity
                "$root&:active": {
                    // Contrast level 2 + level 3
                    backgroundColor: styles_1.alpha(palette.type === "dark"
                        ? palette.common.white
                        : palette.common.offBlack, 0.4),
                },
            },
        },
        clickableColorSecondary: {
            "&:hover, &:focus": { backgroundColor: undefined },
            "&:hover, &.Mui-focusVisible": {
                backgroundColor: palette.type === "dark"
                    ? styles_1.lighten(palette.secondary.main, palette.action.hoverOpacity)
                    : styles_1.darken(palette.secondary.main, palette.action.hoverOpacity),
            },
            "&:active": {
                backgroundColor: palette.type === "dark"
                    ? styles_1.lighten(palette.secondary.main, 0.4)
                    : styles_1.darken(palette.secondary.main, 0.4),
            },
        },
        deletable: {
            "&:focus": {
                // Contrast level 2 + hover
                backgroundColor: styles_1.alpha(palette.type === "dark"
                    ? palette.common.white
                    : palette.common.offBlack, 0.16 + palette.action.hoverOpacity),
                boxShadow: "inset 0 0 0 1px " + palette.text.primary,
            },
        },
        deleteIcon: {
            color: "inherit",
            borderRadius: shape.borderRadius,
            margin: spacing(0, 1, 0, -1),
            "&:hover": {
                color: undefined,
                backgroundColor: palette.action.hover,
            },
            "&:active": {
                backgroundColor: palette.action.active,
            },
        },
        deleteIconSmall: {
            height: spacing(4),
            width: spacing(4),
            marginRight: 0,
            marginLeft: 0,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        },
        deleteIconColorSecondary: {
            color: undefined,
            "&:hover, &:active": {
                color: undefined,
            },
        },
        outlined: {
            border: "1px solid " + palette.dividerStrong,
            "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
                backgroundColor: palette.action.hover,
            },
            "$clickable&:focus, $deletable&:focus": {
                boxShadow: "unset",
                borderColor: palette.text.primary,
            },
        },
        outlinedSecondary: {
            color: undefined,
            border: undefined,
        },
    });
};
exports.createMuiChipOverrides = createMuiChipOverrides;
//# sourceMappingURL=MuiChip.js.map